export const EDIT_MODE = {
  EDIT: "EDIT",
}



/** WEBPACK FOOTER **
 ** ./client/pages/settings/pms/constants.js
 **/